export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/48d0057cf54c678c61fc778c0aeda84f.svg";